module.exports = __webpack_public_path__ + "media/images/brands/logo_francsenergie_grand-d484f66fcf1721e05bb1be03712de8da.svg";